import axios from 'axios';

import {
  SET_CRT_INTERNAL_ID,
  SET_FETCH_NOTARY_CERTIFICATE_STATUS,
  SET_CALCULATE_MERKLE_TREE_ROOT_STATUS,
  SET_MERKLE_TREE_ROOT,
  SET_JSON_ID,
  SET_CRT_HASH_ROOT,
  SET_VALIDATE_HASH_STATUS,
  SET_CALCULATE_CRT_ID_STATUS,
  SET_CALCULATED_CRT_ID,
  SET_VALIDATE_MERKLE_STATUS,
  SET_ITEM_HASH,
  SET_HASH_LIST,
  SET_MERKLE_PROOF,
  SET_HASH_ROOT,
  SET_MERKLE_ROOT,
  SET_TRANSACTION_ID,
  SET_DISPLAY_FILE_NAME,
  SET_CRT_DATE,
  SET_SIGNEE,
  SET_SPL_ITEM_HASH
} from './mutation-types';

import {
  FETCH_NOTARY_CERTIFICATE,
  CALCULATE_MERKLE_TREE_ROOT,
  CALCULATE_CRT_ID,
  UPDATE_VALIDATE_MERKLE_STATUS
} from './action-types';

import {
  PENDING_STATUS,
  UNDEFINED_STATUS
} from './action-status';

import {
  UNDEFINED_VERIFY_STATUS,
  VALID_STATUS,
  INVALID_STATUS
} from './verify-status';

export default {
  async [FETCH_NOTARY_CERTIFICATE]({ commit, dispatch }, crtInternalId) {
    commit(SET_FETCH_NOTARY_CERTIFICATE_STATUS, PENDING_STATUS);
    commit(SET_CRT_INTERNAL_ID, crtInternalId);

    commit(SET_JSON_ID, '');
    commit(SET_ITEM_HASH, '');
    commit(SET_HASH_LIST, []);
    commit(SET_MERKLE_PROOF, []);
    commit(SET_HASH_ROOT, '');
    commit(SET_MERKLE_ROOT, '');
    commit(SET_TRANSACTION_ID, '');
    commit(SET_DISPLAY_FILE_NAME, '');
    commit(SET_CRT_DATE, '');
    commit(SET_SIGNEE, '');
    commit(SET_SPL_ITEM_HASH, '');

    await axios.get('/arCertificateId', {
      params: {
        id: decodeURIComponent(crtInternalId),
        withCrtDate: true
      }
    }).then(function (response) {
      const data = response.data;
      if (data !== undefined) {
        commit(SET_JSON_ID, data.crtIdJson);
        commit(SET_DISPLAY_FILE_NAME, data.displayFileName);
        commit(SET_CRT_DATE, data.crtDate);
        commit(SET_SIGNEE, data.crtSignee);
        commit(SET_SPL_ITEM_HASH, data.splittedItemHash);

        const dataCrt = data.crt;
        if (dataCrt !== undefined) {
          if (dataCrt.hashRoot !== undefined && dataCrt.hashRoot.length > 0) {
            commit(SET_CRT_HASH_ROOT, dataCrt.hashRoot);
            commit(SET_HASH_ROOT, dataCrt.hashRoot);
          } else {
            console.error('The "hash_root" field in archive-reader ' +
              '"GetNotaryInfo" response should not be empty');
          }

          if (dataCrt.itemHash !== undefined && dataCrt.itemHash.length > 0) {
            commit(SET_ITEM_HASH, dataCrt.itemHash);
          } else {
            console.error('The "item_hash" field in archive-reader ' +
              '"GetNotaryInfo" response should not be empty');
          }

          if (dataCrt.hashList !== undefined && dataCrt.hashList.length > 0) {
            commit(SET_HASH_LIST, dataCrt.hashList);
          } else {
            console.error('The "hash_list" field in archive-reader ' +
              '"GetNotaryInfo" response should not be empty');
          }

          commit(SET_MERKLE_PROOF, data.notaryMerkleProof);
          commit(SET_MERKLE_ROOT, data.notaryMerkleRoot);
          commit(SET_TRANSACTION_ID, data.notaryEtheriumTransactionId);
        } else {
          console.error('Invalid archive-reader "GetNotaryInfo" response');
        }
      }
    }).finally(function () {
      commit(SET_FETCH_NOTARY_CERTIFICATE_STATUS, UNDEFINED_STATUS);
    });
  },
  async [CALCULATE_MERKLE_TREE_ROOT]({ commit, dispatch }, args) {
    commit(SET_CALCULATE_MERKLE_TREE_ROOT_STATUS, PENDING_STATUS);
    commit(SET_MERKLE_TREE_ROOT, '');
    commit(SET_JSON_ID, '');
    commit(SET_VALIDATE_HASH_STATUS, UNDEFINED_VERIFY_STATUS);

    await axios.get('/calcMerkleTreeRoot', {
      params: {
        hash: args.hash,
        proof: args.proof
      }
    }).then(function (response) {
      const calculatedHashRoot = response.data.root;
      commit(SET_MERKLE_TREE_ROOT, calculatedHashRoot);
      commit(SET_JSON_ID, response.data.jsonId);

      if (args.crtHashRoot === calculatedHashRoot) {
        commit(SET_VALIDATE_HASH_STATUS, VALID_STATUS);
      } else {
        commit(SET_VALIDATE_HASH_STATUS, INVALID_STATUS);
      }
    }).finally(function () {
      commit(SET_CALCULATE_MERKLE_TREE_ROOT_STATUS, UNDEFINED_STATUS);
    });
  },
  async [CALCULATE_CRT_ID]({ commit, dispatch }, args) {
    commit(SET_CALCULATE_CRT_ID_STATUS, PENDING_STATUS);
    commit(SET_CALCULATED_CRT_ID, '');

    await axios.get('/calcCertificateId', {
      params: {
        jsonid: args.jsonid
      }
    }).then(function (response) {
      commit(SET_CALCULATED_CRT_ID, response.data.id);
    }).finally(function () {
      commit(SET_CALCULATE_CRT_ID_STATUS, UNDEFINED_STATUS);
    });
  },
  [UPDATE_VALIDATE_MERKLE_STATUS]({ commit }, status) {
    commit(SET_VALIDATE_MERKLE_STATUS, status);
  }


};
